import { NavLink, Outlet } from "react-router-dom";
import { LayoutDashboard, Upload, Search, Users, Settings, ScrollText, LogOut, Download } from "lucide-react";
import { Brand } from "@/components/landing/SiteHeader";
import { useAuth } from "@/context/AuthContext";
import { ROLE_LABEL } from "@/components/studio/common";
import { downloadFile } from "@/lib/api";
import { ChangePassword } from "@/components/studio/ChangePassword";
import { toast } from "sonner";

const NAV = [
  ["/studio", "Pratiche", LayoutDashboard, null],
  ["/studio/consap", "Import Consap", Upload, ["admin", "collaboratore"]],
  ["/studio/ricerche", "Log ricerche", Search, ["admin", "collaboratore"]],
  ["/studio/utenti", "Utenti", Users, null],
  ["/studio/impostazioni", "Impostazioni", Settings, null],
  ["/studio/audit", "Audit log", ScrollText, ["admin"]],
];

export default function StudioLayout() {
  const { user, logout } = useAuth();
  const items = NAV.filter(([, , , r]) => !r || r.includes(user.role));
  const exportCsv = () => downloadFile("/admin/export/pratiche.csv", "export_pratiche.csv").catch(() => toast.error("Export non riuscito"));

  return (
    <div className="min-h-screen bg-slate-50 lg:grid lg:grid-cols-[250px_1fr]" data-testid="studio-layout">
      <aside className="bg-navy text-slate-300 lg:min-h-screen lg:sticky lg:top-0 flex lg:flex-col">
        <div className="hidden lg:block p-5 border-b border-white/10"><Brand light small /></div>
        <nav className="flex lg:flex-col gap-1 p-2 lg:p-4 overflow-x-auto flex-1">
          {items.map(([to, label, Icon]) => (
            <NavLink key={to} to={to} end={to === "/studio"} data-testid={`studio-nav-${label.toLowerCase().replace(/ /g, "-")}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm whitespace-nowrap transition-colors ${isActive ? "bg-white/10 text-white" : "hover:bg-white/5 hover:text-white"}`}>
              <Icon className="h-4 w-4 shrink-0" strokeWidth={1.5} />{label}
            </NavLink>
          ))}
          {user.role === "admin" && (
            <button data-testid="studio-export-btn" onClick={exportCsv} className="flex items-center gap-3 px-3 py-2.5 rounded-md text-sm whitespace-nowrap hover:bg-white/5 hover:text-white text-left">
              <Download className="h-4 w-4" strokeWidth={1.5} />Export commercialista
            </button>
          )}
        </nav>
        <div className="hidden lg:block p-4 border-t border-white/10">
          <p className="text-sm text-white font-medium" data-testid="studio-user-name">{user.name}</p>
          <p className="text-xs text-gold">{ROLE_LABEL[user.role]}</p>
          <div className="mt-3 flex flex-col gap-2 items-start">
            <ChangePassword />
            <button data-testid="studio-logout-btn" onClick={logout} className="flex items-center gap-2 text-xs hover:text-white"><LogOut className="h-3.5 w-3.5" />Esci</button>
          </div>
        </div>
        <div className="lg:hidden flex items-center gap-3 px-3 text-slate-300"><ChangePassword />
          <button data-testid="studio-logout-btn-mobile" onClick={logout}><LogOut className="h-4 w-4" /></button></div>
      </aside>
      <main className="p-4 sm:p-8 lg:p-10 min-w-0"><Outlet /></main>
    </div>
  );
}
